export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/store/modals/modal-share-file-v2.store.ts"